// extracted by mini-css-extract-plugin
export default {"root":"pPxiWUZCV8U95xTUu1Jo","text":"CLoiaIIWB0xxPUwn4L83","placeHolderShimmer":"cl9hD4vulE1wrUPnRpmo"};